<div class="form-element-panel" [ngClass]="{'element-hidden': !element.defaultVisible}">
  <div class="element-top">
    <div class="element-top__left">
      <div class="element-question-actions">
        <div class="element-question">
          <app-element-label [element]="element" />
        </div>

        <ul class="element-actions">
          @if (index > 0) {
            <li><a (click)="visibilityEdit.emit()"><i class="far" [ngClass]="visibilityIcon"></i></a></li>
          }
          @if (shouldShowMessagesIcon()) {
            <li><a (click)="toggleMessages()"><i class="far fa-bell"></i>
              @if (activeMessageCount > 0) {
                <span class="badge-count">{{ activeMessageCount < 10 ? activeMessageCount : '9+' }}</span>
              }
            </a>
            </li>
          }
          <li><a (click)="manage.emit()">
            <i class="far fa-cog"></i>
            @if (showCompletionWarning) {
              <span class="badge-count">!</span>
            }
          </a></li>
          @if (!hasEntries || !element.id) {
            <li class="action-remove"><a (click)="remove.emit()"><i class="far fa-trash"></i></a></li>
          }
        </ul>
      </div>

      <ng-content></ng-content>
    </div>

    <div class="element-top__right">
      <ul class="element-order-actions">
        <li><a (click)="moveUp.emit()"><i class="far fa-angle-up"></i></a></li>
        <li><a (click)="moveDown.emit()"><i class="far fa-angle-down"></i></a></li>
      </ul>
    </div>
  </div>

  @if (!element.defaultVisible && hasVisibilityConditions) {
    <pgo-callout size="sm" variant="warning" style="margin-top: 20px;"><span>{{ visibilityDescription }}</span></pgo-callout>
  }

  <app-element-messages
    [messages]="element.messages"
    [expanded]="messagesExpanded"
    (closed)="toggleMessages()"
    (addClick)="onHandleAddMessage()"
    (editClick)="editMessage.emit($event)"
    (removeClick)="removeMessage.emit($event)"
  />
</div>
